import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


toast.configure();
export const Switch = memo((props) => {
  const { cm, item, usingItems } = props;

  // 初期設定
  const [currentSwitch, setCurrentSwitch] = useState(item);
  const [currentSwitchTransJa, setCurrentSwitchTransJa] = useState([]);
  const [currentSwitchTransEn, setCurrentSwitchTransEn] = useState([]);
  const [isUsing, setIsUsing] = useState();
  useEffect(() => {
    currentSwitch.translations_attributes.map(tran => {
      if (tran.locale === "ja") {
        setCurrentSwitchTransJa(tran);
      } else {
        setCurrentSwitchTransEn(tran);
      }
    });

    let initUsingItem = usingItems.find(CurrentUsingItem => CurrentUsingItem["switch_id"] === currentSwitch.id);
    if (initUsingItem) {
      setIsUsing(initUsingItem);
    } else {
      setIsUsing(false);
    }
  }, []);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onClickInactivateSubmit = (usingItem) => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.delete(`/agent/switchings/${usingItem.id}`)
    .then(resp => {
      console.log(resp);
      setIsUsing(false);
      notify("success", "Switch successfully Inactivated!");
    })
    .catch(e => {
      console.log(e.response);
      console.log("Switch Inactive Error");
    })
  }

  const onClickActivateSubmit = (switch_id) => {
    var data = { switch: { switch_id: switch_id }};

    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    axios.post(`/agent/cm/${cm}/switchings`, data)
    .then(resp => {
      console.log(resp.data);
      setIsUsing(resp.data);
      notify("success", "Switch successfully Activated!");
    })
    .catch(e => {
      console.log(e.response);
      console.log("Switch Active Error");
    })
  }

  return (
    <tr>
      <td>{currentSwitch.code}</td>
      <td>
        {currentSwitchTransJa.name}
        <br/>
        {(!currentSwitchTransJa.description) ? "" : `(${currentSwitchTransJa.description})`}
      </td>
      <td>
        {currentSwitchTransEn.name}
        <br/>
        {(!currentSwitchTransEn.description) ? "" : `(${currentSwitchTransEn.description})`}
      </td>
      <td>
        {isUsing ?
          <button className='btn btn-primary' title="Inactivate"
            onClick={() => onClickInactivateSubmit(isUsing)}>
            <i className="fas fa-pencil-alt" /> 使用中
          </button>
          :
          <button className='btn btn-warning' title="Activate"
            onClick={() => onClickActivateSubmit(currentSwitch.id)}>
            <i className="fas fa-pencil-alt" /> 未使用
          </button>
        }
      </td>
    </tr>
  );
});
